export const styles = (fontWeight, fontSize) => ({
  fontFamily: 'Montserrat, sans-serif',
  fontStyle: 'normal',
  lineHeight: '143%',
  textAlign: 'left',
  fontWeight,
  fontSize,
});
